// python3 server
export default {
    translationFetchUrl: 'https://cankado-permanent-bucket.s3.amazonaws.com/',
    apiRoot: 'https://python3-api.kraftvoll.co',
};